var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.707 5.636a4 4 0 015.657 5.657l-2.475 2.475-1.414-1.414 2.474-2.475a2 2 0 00-2.828-2.829l-2.475 2.475-1.414-1.414 2.475-2.475zm3.182 3.89l-6.364 6.363-1.414-1.414 6.364-6.364 1.414 1.414zM5.636 18.363a4 4 0 005.657 0l2.474-2.475-1.414-1.414-2.475 2.475A2 2 0 017.05 14.12l2.475-2.475-1.414-1.414-2.475 2.475a4 4 0 000 5.657z",
    fill: "#fff"
  })));
}

export default SvgLinkIcon;